import { useCallback } from 'react';

import { useNavigate } from 'react-router-dom';

import { useAppSelector } from '@pkg/hooks';

export const useGoBack = () => {
    const navigate = useNavigate();
    const goBack = useAppSelector((state) => state.detailView.goBack);
    const backUrl = '/';

    const handleBack = useCallback(() => {
        if (goBack) {
            navigate(-1);
        } else {
            navigate(backUrl);
        }
        setTimeout(() => {
            window.scroll(0, 0);
        }, 100);
    }, [goBack, backUrl, navigate]);

    return { handleBack, goBackEnabled: goBack, backUrl };
};
